import _ from 'lodash'

const validateRating = (requiredRatings, allRatings) => {
  _.each(Object.keys(requiredRatings), (value) => {
    const requiredIndex = ratingsIndex[value]

    allRatings = allRatings.map((r, index) => {
      if (index >= requiredIndex && r >= requiredRatings[value]) {
        r = r - requiredRatings[value]
        requiredRatings[value] = 0
      } else if (r > 0) {
        r = 0
        requiredRatings[value] = requiredRatings[value] - r
      } else if (index === Object.keys(ratingsIndex).length - 1) {
        r = r - requiredRatings[value]
      }

      return r
    })
  })

  return allRatings[4] >= 0
}

const ratingsIndex = {
  A: 4,
  B: 3,
  C: 2,
  D: 1,
  E: 0
}

const getPossibleRating = (tournament) => {
  const ratings = tournament.participants.reduce((total, participant) => {
    const newTotal = total
    newTotal[ratingsIndex[participant.rating]] += 1

    return newTotal
  }, [0, 0, 0, 0, 0])

  const totalParticipants = tournament.participants.length

  let eventRating = 'NR'
  let eventSubrating = ''

  if (totalParticipants >= 5) eventSubrating = '1'
  if (totalParticipants >= 7) eventSubrating = '2'
  if (totalParticipants >= 13) eventSubrating = '3'
  if (totalParticipants >= 25) eventSubrating = '4'

  if (eventSubrating === '1') {
    if (validateRating({ C: 1, A: 1 }, ratings)) {
      eventRating = 'A'
    } else if (validateRating({ D: 1, B: 1 }, ratings)) {
      eventRating = 'B'
    } else if (validateRating({ E: 1, C: 1 }, ratings)) {
      eventRating = 'C'
    } else if (validateRating({ D: 1 }, ratings)) {
      eventRating = 'D'
    } else {
      eventRating = 'E'
    }
  }
  if (eventSubrating === '2') {
    if (validateRating({ E: 2, D: 1, C: 1, A: 1 }, ratings) || validateRating({ E: 1, D: 2, C: 1, B: 1 }, ratings)) {
      eventRating = 'A'
    } else if (validateRating({ E: 1, D: 2, B: 1 }, ratings) || validateRating({ E: 2, D: 2, C: 1 }, ratings)) {
      eventRating = 'B'
    } else if (validateRating({ E: 3, C: 1 }, ratings) || validateRating({ E: 2, D: 2 }, ratings)) {
      eventRating = 'C'
    } else if (validateRating({ D: 1 }, ratings) || validateRating({ E: 2 }, ratings)) {
      eventRating = 'D'
    } else {
      eventRating = 'E'
    }
  }
  if (eventSubrating === '3') {
    if (validateRating({ E: 3, D: 3, C: 2, B: 1, A: 1 }, ratings) || validateRating({ E: 4, D: 3, C: 2, B: 2 }, ratings)) {
      eventRating = 'A'
    } else if (validateRating({ E: 3, D: 2, C: 2, B: 1 }, ratings) || validateRating({ E: 4, D: 3, C: 2 }, ratings)) {
      eventRating = 'B'
    } else if (validateRating({ E: 2, D: 3, C: 1 }, ratings) || validateRating({ E: 5, D: 3 }, ratings)) {
      eventRating = 'C'
    } else if (validateRating({ E: 1, D: 1 }, ratings) || validateRating({ E: 3 }, ratings)) {
      eventRating = 'D'
    } else {
      eventRating = 'E'
    }
  }
  if (eventSubrating === '4') {
    if (validateRating({ E: 4, D: 4, C: 3, B: 3, A: 3 }, ratings) || validateRating({ E: 6, D: 5, C: 5, B: 4 }, ratings)) {
      eventRating = 'A'
    } else if (validateRating({ E: 3, D: 4, C: 3, B: 3 }, ratings) || validateRating({ E: 6, D: 5, C: 5 }, ratings)) {
      eventRating = 'B'
    } else if (validateRating({ E: 4, D: 4, C: 3 }, ratings) || validateRating({ E: 7, D: 7 }, ratings)) {
      eventRating = 'C'
    } else if (validateRating({ E: 2, D: 2 }, ratings) || validateRating({ E: 6 }, ratings)) {
      eventRating = 'D'
    } else {
      eventRating = 'E'
    }
  }

  return `${eventRating}${eventSubrating}`
}

const getFinalRating = (tournament) => {
  const totalParticipants = tournament.participants.length
  let eventRating = 'NR'
  let eventSubrating = ''

  if (totalParticipants >= 5) {
    eventSubrating = '1'
    const filteredPlaces = tournament.participants.filter(p => p.place <= 2)
    const countEs = (filteredPlaces.filter(p => p.rating === 'E')).length
    const countDs = (filteredPlaces.filter(p => p.rating === 'D')).length
    const countCs = (filteredPlaces.filter(p => p.rating === 'C')).length
    const countBs = (filteredPlaces.filter(p => p.rating === 'B')).length
    const countAs = (filteredPlaces.filter(p => p.rating === 'A')).length

    if ((countAs >= 1 && (countEs >= 1 || countAs + countBs + countCs + countDs + countEs >= 2))) {
      eventRating = 'A'
    } else if (countBs >= 1 || countAs + countBs >= 1) {
      eventRating = 'B'
    } else if (countCs >= 1 || countAs + countBs + countCs >= 1) {
      eventRating = 'C'
    } else if (countDs >= 1 || countAs + countBs + countCs + countDs >= 1) {
      eventRating = 'D'
    } else {
      eventRating = 'E'
    }
  }
  if (totalParticipants >= 7) {
    eventSubrating = '2'
    const filteredPlaces = tournament.participants.filter(p => p.place <= 4)
    const countEs = filteredPlaces.filter(p => p.rating === 'E').length
    const countDs = filteredPlaces.filter(p => p.rating === 'D').length
    const countCs = filteredPlaces.filter(p => p.rating === 'C').length
    const countBs = filteredPlaces.filter(p => p.rating === 'B').length
    const countAs = filteredPlaces.filter(p => p.rating === 'A').length

    if ((countAs >= 1 &&
      (countCs >= 1 || countAs + countBs + countCs >= 2) &&
      (countEs >= 1 || countAs + countBs + countCs + countDs + countEs >= 3)) ||
      ((countBs >= 1 || countAs + countBs >= 1) &&
      (countCs >= 1 || countAs + countBs + countCs >= 2) &&
      (countDs >= 1 || countAs + countBs + countCs + countDs >= 3))
    ) {
      eventRating = 'A'
    } else if (((countBs >= 1 || countAs + countBs >= 1) &&
      (countDs >= 1 || countAs + countBs + countCs + countDs >= 2) &&
      (countEs >= 1 || countAs + countBs + countCs + countDs + countEs >= 3)) ||
      ((countCs >= 2 || countAs + countBs + countCs >= 2))
    ) {
      eventRating = 'B'
    } else if (((countCs >= 1 || countAs + countBs + countCs >= 1) &&
      (countEs >= 1 || countAs + countBs + countCs + countDs + countEs >= 2)) ||
      ((countDs >= 2 || countAs + countBs + countCs + countDs >= 2))
    ) {
      eventRating = 'C'
    } else if (((countDs >= 1 || countAs + countBs + countCs + countDs >= 1)) ||
      ((countEs >= 2 || countAs + countBs + countCs + countDs + countEs >= 2))
    ) {
      eventRating = 'D'
    } else {
      eventRating = 'E'
    }
  }
  if (totalParticipants >= 13) {
    eventSubrating = '3'
    const filteredPlaces = tournament.participants.filter(p => p.place <= 8)
    const countEs = filteredPlaces.filter(p => p.rating === 'E').length
    const countDs = filteredPlaces.filter(p => p.rating === 'D').length
    const countCs = filteredPlaces.filter(p => p.rating === 'C').length
    const countBs = filteredPlaces.filter(p => p.rating === 'B').length
    const countAs = filteredPlaces.filter(p => p.rating === 'A').length

    if ((countAs >= 1 &&
      (countBs >= 1 || countAs + countBs >= 2) &&
      (countCs >= 1 || countAs + countBs + countCs >= 3) &&
      (countDs >= 2 || countAs + countBs + countCs + countDs >= 5) &&
      (countEs >= 1 || countAs + countBs + countCs + countDs + countEs >= 6)) ||
      ((countBs >= 2 || countAs + countBs >= 2) &&
      (countCs >= 2 || countAs + countBs + countCs >= 4) &&
      (countDs >= 1 || countAs + countBs + countCs + countDs >= 5) &&
      (countEs >= 1 || countAs + countBs + countCs + countDs + countEs >= 6))
    ) {
      eventRating = 'A'
    } else if (((countAs + countBs >= 1) &&
      (countAs + countBs + countCs >= 2) &&
      (countAs + countBs + countCs + countDs >= 4) &&
      (countAs + countBs + countCs + countDs + countEs >= 6)) ||
      ((countAs + countBs + countCs >= 2) &&
      (countAs + countBs + countCs + countDs >= 4) &&
      (countAs + countBs + countCs + countDs + countEs >= 6))
    ) {
      eventRating = 'B'
    } else if (((countCs >= 2 || countAs + countBs + countCs >= 2) &&
      (countDs >= 1 || countAs + countBs + countCs + countDs >= 3)) ||
      ((countDs >= 3 || countAs + countBs + countCs + countDs >= 3) &&
      (countEs >= 2 || countAs + countBs + countCs + countDs + countEs >= 5))
    ) {
      eventRating = 'C'
    } else if (((countDs >= 1 || countAs + countBs + countCs + countDs >= 1) &&
      (countEs >= 1 || countAs + countBs + countCs + countDs + countEs >= 2)) ||
      ((countEs >= 3 || countAs + countBs + countCs + countDs + countEs >= 3))
    ) {
      eventRating = 'D'
    } else {
      eventRating = 'E'
    }
  }
  if (totalParticipants >= 25) {
    eventSubrating = '4'
    const filteredPlaces = tournament.participants.filter(p => p.place <= 16)
    const countEs = filteredPlaces.filter(p => p.rating === 'E').length
    const countDs = filteredPlaces.filter(p => p.rating === 'D').length
    const countCs = filteredPlaces.filter(p => p.rating === 'C').length
    const countBs = filteredPlaces.filter(p => p.rating === 'B').length
    const countAs = filteredPlaces.filter(p => p.rating === 'A').length

    if ((countAs >= 2 &&
      (countBs >= 3 || countAs + countBs >= 5) &&
      (countCs >= 2 || countAs + countBs + countCs >= 7) &&
      (countDs >= 2 || countAs + countBs + countCs + countDs >= 9) &&
      (countEs >= 2 || countAs + countBs + countCs + countDs + countEs >= 11)) ||
      ((countBs >= 4 || countAs + countBs >= 4) &&
      (countCs >= 3 || countAs + countBs + countCs >= 7) &&
      (countDs >= 3 || countAs + countBs + countCs + countDs >= 10) &&
      (countEs >= 3 || countAs + countBs + countCs + countDs + countEs >= 13))
    ) {
      eventRating = 'A'
    } else if (((countBs >= 3 || countAs + countBs >= 3) &&
      (countCs >= 2 || countAs + countBs + countCs >= 5) &&
      (countDs >= 2 || countAs + countBs + countCs + countDs >= 7) &&
      (countEs >= 1 || countAs + countBs + countCs + countDs + countEs >= 8)) ||
      ((countCs >= 4 || countAs + countBs + countCs >= 4) &&
      (countDs >= 4 || countAs + countBs + countCs + countDs >= 8) &&
      (countEs >= 3 || countAs + countBs + countCs + countDs + countEs >= 11))
    ) {
      eventRating = 'B'
    } else if (((countCs >= 3 || countAs + countBs + countCs >= 3) &&
      (countDs >= 2 || countAs + countBs + countCs + countDs >= 5) &&
      (countEs >= 3 || countAs + countBs + countCs + countDs + countEs >= 8)) ||
      ((countDs >= 5 || countAs + countBs + countCs + countDs >= 5) &&
      (countEs >= 6 || countAs + countBs + countCs + countDs + countEs >= 11))
    ) {
      eventRating = 'C'
    } else if (((countDs >= 2 || countAs + countBs + countCs + countDs >= 2) &&
      (countEs >= 1 || countAs + countBs + countCs + countDs + countEs >= 1)) ||
      ((countEs >= 5 || countAs + countBs + countCs + countDs + countEs >= 5))
    ) {
      eventRating = 'D'
    } else {
      eventRating = 'E'
    }
  }

  return `${eventRating}${eventSubrating}`
}

const promoteParticipants = (tournament) => {
  const finalRating = getFinalRating(tournament)

  tournament.rating = finalRating

  switch (finalRating) {
    case 'A4': {
      if (tournament.participants[0].rating >= 'A') {
        tournament.participants[0].rankPromotion = 'A'
      }
      if (tournament.participants[1].rating >= 'B') {
        tournament.participants[1].rankPromotion = 'B'
      }
      [2, 3].forEach((value) => {
        if (tournament.participants[value].rating >= 'C') {
          tournament.participants[value].rankPromotion = 'C'
        }
      });
      [4, 5, 6, 7].forEach(value => {
        if (tournament.participants[value].rating >= 'D') {
          tournament.participants[value].rankPromotion = 'D'
        }
      });
      [8, 9, 10, 11, 12, 13, 14, 15].forEach(value => {
        if (tournament.participants[value].rating >= 'E') {
          tournament.participants[value].rankPromotion = 'E'
        }
      })
      break
    }
    case 'B4': {
      [0, 1].forEach((value) => {
        if (tournament.participants[value].rating >= 'B') {
          tournament.participants[value].rankPromotion = 'B'
        }
      });
      [2, 3].forEach((value) => {
        if (tournament.participants[value].rating >= 'C') {
          tournament.participants[value].rankPromotion = 'C'
        }
      });
      [4, 5, 6, 7].forEach(value => {
        if (tournament.participants[value].rating >= 'D') {
          tournament.participants[value].rankPromotion = 'D'
        }
      });
      [8, 9, 10, 11, 12, 13, 14, 15].forEach(value => {
        if (tournament.participants[value].rating >= 'E') {
          tournament.participants[value].rankPromotion = 'E'
        }
      })
      break
    }
    case 'C4': {
      [0, 1].forEach((value) => {
        if (tournament.participants[value].rating >= 'C') {
          tournament.participants[value].rankPromotion = 'C'
        }
      });
      [2, 3, 4, 5, 6, 7].forEach(value => {
        if (tournament.participants[value].rating >= 'D') {
          tournament.participants[value].rankPromotion = 'D'
        }
      });
      [8, 9, 10, 11, 12, 13, 14, 15].forEach(value => {
        if (tournament.participants[value].rating >= 'E') {
          tournament.participants[value].rankPromotion = 'E'
        }
      })
      break
    }
    case 'D4': {
      [0, 1, 2, 3, 4, 5, 6, 7].forEach(value => {
        if (tournament.participants[value].rating >= 'D') {
          tournament.participants[value].rankPromotion = 'D'
        }
      });
      [8, 9, 10, 11, 12, 13, 14, 15].forEach(value => {
        if (tournament.participants[value].rating >= 'E') {
          tournament.participants[value].rankPromotion = 'E'
        }
      })
      break
    }
    case 'E4': {
      [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15].forEach(value => {
        if (tournament.participants[value].rating >= 'E') {
          tournament.participants[value].rankPromotion = 'E'
        }
      })
      break
    }
    case 'A3': {
      if (tournament.participants[0].rating >= 'A') {
        tournament.participants[0].rankPromotion = 'A'
      }
      if (tournament.participants[1].rating >= 'B') {
        tournament.participants[1].rankPromotion = 'B'
      }
      [2, 3].forEach((value) => {
        if (tournament.participants[value].rating >= 'C') {
          tournament.participants[value].rankPromotion = 'C'
        }
      });
      [4, 5, 6, 7].forEach(value => {
        if (tournament.participants[value].rating >= 'D') {
          tournament.participants[value].rankPromotion = 'D'
        }
      })
      break
    }
    case 'B3': {
      [0].forEach((value) => {
        if (tournament.participants[value].rating >= 'B') {
          tournament.participants[value].rankPromotion = 'B'
        }
      });
      [1].forEach((value) => {
        if (tournament.participants[value].rating >= 'C') {
          tournament.participants[value].rankPromotion = 'C'
        }
      });
      [2, 3].forEach(value => {
        if (tournament.participants[value].rating >= 'D') {
          tournament.participants[value].rankPromotion = 'D'
        }
      });
      [4, 5, 6, 7].forEach(value => {
        if (tournament.participants[value].rating >= 'E') {
          tournament.participants[value].rankPromotion = 'E'
        }
      })
      break
    }
    case 'C3': {
      [0].forEach((value) => {
        if (tournament.participants[value].rating >= 'C') {
          tournament.participants[value].rankPromotion = 'C'
        }
      });
      [1, 2, 3].forEach(value => {
        if (tournament.participants[value].rating >= 'D') {
          tournament.participants[value].rankPromotion = 'D'
        }
      });
      [4, 5, 6, 7].forEach(value => {
        if (tournament.participants[value].rating >= 'E') {
          tournament.participants[value].rankPromotion = 'E'
        }
      })
      break
    }
    case 'D3': {
      [0, 1, 2].forEach(value => {
        if (tournament.participants[value].rating >= 'D') {
          tournament.participants[value].rankPromotion = 'D'
        }
      });
      [3, 4, 5, 6, 7].forEach(value => {
        if (tournament.participants[value].rating >= 'E') {
          tournament.participants[value].rankPromotion = 'E'
        }
      })
      break
    }
    case 'E3': {
      [0, 1, 2, 3, 4, 5, 6, 7].forEach(value => {
        if (tournament.participants[value].rating >= 'E') {
          tournament.participants[value].rankPromotion = 'E'
        }
      })
      break
    }
    case 'A2': {
      if (tournament.participants[0].rating >= 'A') {
        tournament.participants[0].rankPromotion = 'A'
      }
      if (tournament.participants[1].rating >= 'B') {
        tournament.participants[1].rankPromotion = 'B'
      }
      [2, 3].forEach((value) => {
        if (tournament.participants[value].rating >= 'C') {
          tournament.participants[value].rankPromotion = 'C'
        }
      })
      break
    }
    case 'B2': {
      [0].forEach((value) => {
        if (tournament.participants[value].rating >= 'B') {
          tournament.participants[value].rankPromotion = 'B'
        }
      });
      [1].forEach((value) => {
        if (tournament.participants[value].rating >= 'C') {
          tournament.participants[value].rankPromotion = 'C'
        }
      });
      [2, 3].forEach(value => {
        if (tournament.participants[value].rating >= 'D') {
          tournament.participants[value].rankPromotion = 'D'
        }
      })
      break
    }
    case 'C2': {
      [0].forEach((value) => {
        if (tournament.participants[value].rating >= 'C') {
          tournament.participants[value].rankPromotion = 'C'
        }
      });
      [1].forEach(value => {
        if (tournament.participants[value].rating >= 'D') {
          tournament.participants[value].rankPromotion = 'D'
        }
      });
      [2, 3].forEach(value => {
        if (tournament.participants[value].rating >= 'E') {
          tournament.participants[value].rankPromotion = 'E'
        }
      })
      break
    }
    case 'D2': {
      [0].forEach(value => {
        if (tournament.participants[value].rating >= 'D') {
          tournament.participants[value].rankPromotion = 'D'
        }
      });
      [1, 2, 3].forEach(value => {
        if (tournament.participants[value].rating >= 'E') {
          tournament.participants[value].rankPromotion = 'E'
        }
      })
      break
    }
    case 'E2': {
      [0, 1, 2, 3].forEach(value => {
        if (tournament.participants[value].rating >= 'E') {
          tournament.participants[value].rankPromotion = 'E'
        }
      })
      break
    }
    case 'A1': {
      if (tournament.participants[0].rating >= 'A') {
        tournament.participants[0].rankPromotion = 'A'
      }
      if (tournament.participants[1].rating >= 'B') {
        tournament.participants[1].rankPromotion = 'B'
      }
      break
    }
    case 'B1': {
      [0].forEach((value) => {
        if (tournament.participants[value].rating >= 'B') {
          tournament.participants[value].rankPromotion = 'B'
        }
      });
      [1].forEach((value) => {
        if (tournament.participants[value].rating >= 'C') {
          tournament.participants[value].rankPromotion = 'C'
        }
      })
      break
    }
    case 'C1': {
      [0].forEach((value) => {
        if (tournament.participants[value].rating >= 'C') {
          tournament.participants[value].rankPromotion = 'C'
        }
      });
      [1].forEach(value => {
        if (tournament.participants[value].rating >= 'D') {
          tournament.participants[value].rankPromotion = 'D'
        }
      })
      break
    }
    case 'D1': {
      [0].forEach(value => {
        if (tournament.participants[value].rating >= 'D') {
          tournament.participants[value].rankPromotion = 'D'
        }
      });
      [1].forEach(value => {
        if (tournament.participants[value].rating >= 'E') {
          tournament.participants[value].rankPromotion = 'E'
        }
      })
      break
    }
    case 'E1': {
      [0, 1].forEach(value => {
        if (tournament.participants[value].rating >= 'E') {
          tournament.participants[value].rankPromotion = 'E'
        }
      })
      break
    }
    default: {
      console.log('non-rated tournament')
    }
  }

  tournament.participants = tournament.participants.map(p => {
    if (p.rankPromotion === p.rating) {
      p.rankPromotion = '-'
    }
    return p
  })

  return tournament
}

export {
  getPossibleRating,
  getFinalRating,
  promoteParticipants
}
